<template>
  <div v-loading="page_loading" class="page-container">
    <el-card class="mb-20">
      <div class="container">
        <label>应用APP：</label>
        <el-select v-model="app_value" placeholder="请选择应用" size="mini">
          <el-option
            v-for="item in app_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <label class="ml-20">返点：</label>
        <el-input-number v-model="rebate_value" :min="0" :precision="4" placeholder="请输入返点" size="mini" class="mr-20" />
        <el-button type="primary" size="mini" @click="setAllRebate">设置</el-button>
      </div>
    </el-card>
    <el-card>
      <div class="mb-20 fr">
        <el-button type="primary" size="mini" @click="openDialog(1)">APP配置</el-button>
      </div>
      <app-table
        ref="app-table"
        :table-key="table_key"
        :get-data="getConfigList"
        :is-current-page="false"
      />
    </el-card>
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      width="500px"
    >
      <app-form
        v-if="dialog_config.is_show"
        ref="ad_form"
        :form-data="dialog_config.form_config"
        default-label-width="100px"
        @confirm="confirm"
        @cancel="cancel"
      />
    </el-dialog>
    <!-- 广告主ID授权弹窗 -->
    <el-dialog
      :title="advertiser_auth_config.title"
      :visible.sync="advertiser_auth_config.is_show"
      width="500px"
    >
      <app-form
        v-if="advertiser_auth_config.is_show"
        :form-data="advertiser_auth_config.form_config"
        default-label-width="110px"
        @confirm="advertiser_auth_config.confirm"
        @cancel="advertiser_auth_config.is_show = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  updateOrCreateConfigApi,
  getConfigApi,
  delConfigApi,
  updateSelfAndSubRebateApi,
  getGrantUrlApi,
  authApi,
  addAdvertiserApi,
} from '@/api/put-in';
import { formDataAssign } from '@/tools/form';
import { getPageConfig, AUTH_TYPE } from '@/views/system/put-in-setting/config';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
  },
  data() {
    return {
      /** 页面配置 */
      page_config: {},
      /** 表格头部 */
      table_key: require('./model/table-key.js')(this),
      /** 弹窗配置 */
      dialog_config: {
        is_show: false,
        title: 'APP配置',
        type: 1,
        form_config: {},
      },
      /** 应用APP选项 */
      app_options: [],
      /** 应用APP值 */
      app_value: '',
      /** 返点值 */
      rebate_value: 0,
      /** 页面loading */
      page_loading: false,
      /** 广告主账户授权配置 */
      advertiser_auth_config: {
        is_show: false,
        title: '授权账户',
        app_id: '',
        form_config: {
          advertiser_id: {
            label: '广告主账户ID',
            type: 'input',
            value: '',
            rules: { required: true, message: '请输入广告主账户ID', trigger: 'change' },
          },
        },
        confirm: (params) => {
          addAdvertiserApi({ channel_interface: this.page_config.channel_interface, app_id: this.advertiser_auth_config.app_id, ...params }).then(({ message }) => {
            this.$message.success(message || '授权成功');
            this.advertiser_auth_config.is_show = false;
            this.$refs['app-table'].refer();
          });
        },
      },
    };
  },
  watch: {
    '$route': {
      handler(to) {
        const { permissions } = to.meta || {};
        const page_config = getPageConfig(permissions);
        Object.assign(this.page_config, page_config);
      },
      immediate: true,
    },
  },
  methods: {
    /** 获取列表 */
    getConfigList() {
      return new Promise((resolve, reject) => {
        getConfigApi({ channel_interface: this.page_config.channel_interface }).then(res => {
          if (this.app_options.length === 0) {
            this.app_options = res.map(item => {
              return {
                label: item.app_name,
                value: item.app_id,
              };
            });
          }
          resolve(res);
        }).catch(reject);
      });
    },
    /** 设置返点 */
    setAllRebate() {
      if (!this.app_value) {
        this.$message.warning('请选择应用APP！');
        return;
      }
      if (!this.rebate_value && this.rebate_value !== 0) {
        this.$message.warning('请输入返点！');
        return;
      }
      this.$confirm('此操作将修改代理商及其下所有授权账户的返点，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        updateSelfAndSubRebateApi({
          channel_interface: this.page_config.channel_interface,
          app_id: this.app_value,
          rebate: this.rebate_value,
        }).then(() => {
          this.$message({
            type: 'success',
            message: '设置成功!',
          });
          this.$refs['app-table'].refer();
        });
      });
    },
    /** 打开APP配置弹窗
     * @param {number} type 1 = 新增，2 = 编辑
     * @param {number} data 列表项数据
     */
    openDialog(type, data) {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: type === 1 ? 'APP配置' : '编辑',
        type,
        form_config: require('./model/form-config.js')(),
      });

      type === 2 && formDataAssign(this.dialog_config.form_config, data);
    },
    /** APP配置弹窗确认 */
    confirm(params) {
      updateOrCreateConfigApi({
        channel_interface: this.page_config.channel_interface,
        config: [params],
      }).then(() => {
        this.$message({
          type: 'success',
          message: '设置成功!',
        });
        this.dialog_config.is_show = false;
        this.$refs['app-table'].refer();
      });
    },
    /** APP配置弹窗取消 */
    cancel() {
      this.dialog_config.is_show = false;
    },
    /** 删除列表项 */
    delConfig(id) {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        delConfigApi(id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.$refs['app-table'].refer();
        });
      });
    },
    /**
     * 授权
     * @param {string} app_id 应用id
     */
    onAuth(app_id) {
      const map_tuple = [
        // 链接授权
        [
          () => this.page_config.auth_type === AUTH_TYPE.LINK,
          (app_id) => this.onLinkAuth(app_id),
        ],
        // 自动授权
        [
          () => this.page_config.auth_type === AUTH_TYPE.AUTO,
          (app_id) => this.onAutoAuth(app_id),
        ],
        // 广告主ID授权
        [
          () => this.page_config.auth_type === AUTH_TYPE.ADVERTISER_ID,
          (app_id) => this.onAdvertiserIdAuth(app_id),
        ],
      ];

      map_tuple.find(([condition]) => condition())?.[1]?.(app_id);
    },
    /**
     * 链接授权
     * @param app_id
     */
    onLinkAuth(app_id) {
      getGrantUrlApi({
        channel_interface: this.page_config.channel_interface,
        app_id,
      }).then(res => {
        if (res.grant_url) {
          window.open(res.grant_url, '_blank');
        } else {
          this.$message.warning('该渠道暂无授权链接！');
        }
      });
    },
    /**
     * 自动授权
     * @param app_id
     */
    onAutoAuth(app_id) {
      this.page_loading = true;
      authApi({
        channel_interface: this.page_config.channel_interface,
        app_id,
      }).then(() => {
        this.$message.success('授权成功！');
      }).finally(() => {
        this.page_loading = false;
      });
    },
    /**
     * 广告主ID授权
     * @param app_id
     */
    onAdvertiserIdAuth(app_id) {
      this.advertiser_auth_config.form_config.advertiser_id.value = '';
      Object.assign(this.advertiser_auth_config, { is_show: true, app_id });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
}
</style>
